import { render, staticRenderFns } from "./allot-belonger.vue?vue&type=template&id=62bab15e&scoped=true"
import script from "./allot-belonger.vue?vue&type=script&lang=js"
export * from "./allot-belonger.vue?vue&type=script&lang=js"
import style0 from "./allot-belonger.vue?vue&type=style&index=0&id=62bab15e&prod&lang=css"
import style1 from "../../../company/statistics/css/commonCompany.css?vue&type=style&index=1&id=62bab15e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bab15e",
  null
  
)

export default component.exports